import React from "react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-32 border-t" style={{ borderColor: "rgba(184,153,104,0.2)" }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-sm" style={{ color: "#4A4744" }}>
        <div>
          <div className="font-serif-display text-2xl mb-2" style={{ color: "#2C2A28" }}>Santa Chiara</div>
          <p style={{ color: "#75716C" }}>Gelati</p>
        </div>
        <div>
          <div className="eyebrow mb-3">Locations</div>
          <p>5241 Center Blvd, Long Island City, NY 11101</p>
          <p className="mt-2">227 West St, Brooklyn, NY 11222</p>
        </div>
        <div>
          <div className="eyebrow mb-3">Promise</div>
          <p>Nationwide USA delivery within 48 hours · Pickup at Santa Chiara</p>
        </div>
      </div>
      <div className="text-center py-6 text-xs" style={{ color: "#75716C" }}>
        © {new Date().getFullYear()} Santa Chiara · Crafted in Italy, served in New York.
      </div>
    </footer>
  );
}
